import { connect } from "react-redux";
import TableComponent from "../components/Table.Component";
import * as tableActions from "../commands/table.actions";

function mapStateToProps(state) {
  return {
    tables: state.tables,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setUpTable: (tableKey, columns, selections) => {
      dispatch(tableActions.set_up_table(tableKey, columns, selections));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TableComponent);
